import { RastreioCancerPerguntaOpcaoEnum } from 'graphql/types.generated'

import { MamografiaPerguntaField } from '../model-mamografia'

export const tipoMamografiaOptions = [
  { value: RastreioCancerPerguntaOpcaoEnum.DIAGNOSTICO, label: 'Diagnóstica' },
  { value: RastreioCancerPerguntaOpcaoEnum.RASTREAMENTO, label: 'Rastreamento' },
]

export const descargaPapilarOptions = [
  { value: RastreioCancerPerguntaOpcaoEnum.CRISTALINA, label: 'Cristalina' },
  { value: RastreioCancerPerguntaOpcaoEnum.HEMORRAGICA, label: 'Hemorrágica' },
]

export const linfonodoPalpavelOptions = [
  { value: RastreioCancerPerguntaOpcaoEnum.AXILAR, label: 'Axilar' },
  { value: RastreioCancerPerguntaOpcaoEnum.SUPRACLAVICULAR, label: 'Supraclavicular' },
]

export const controleRadioAccordionOptions = [
  {
    label: 'Nódulo',
    name: MamografiaPerguntaField.noduloControleRadio,
  },
  {
    label: 'Microcalcificações',
    name: MamografiaPerguntaField.microcalcificacoesControleRadio,
  },
  {
    label: 'Assimetria focal',
    name: MamografiaPerguntaField.assimetriaFocalControleRadio,
  },
  {
    label: 'Assimetria difusa',
    name: MamografiaPerguntaField.assimetriaDifusaControleRadio,
  },
  {
    label: 'Área densa',
    name: MamografiaPerguntaField.areaDensaControleRadio,
  },
  {
    label: 'Distorção focal',
    name: MamografiaPerguntaField.distorcaoFocalControleRadio,
  },
  {
    label: 'Linfonodo axilar',
    name: MamografiaPerguntaField.linfonodoAxilarControleRadio,
  },
]

export const lesaoCancerAccordionOptions = [
  {
    label: 'Nódulo',
    name: MamografiaPerguntaField.noduloLesaoCancer,
  },
  {
    label: 'Microcalcificações',
    name: MamografiaPerguntaField.microcalcificacoesLesaoCancer,
  },
  {
    label: 'Assimetria focal',
    name: MamografiaPerguntaField.assimetriaFocalLesaoCancer,
  },
  {
    label: 'Assimetria difusa',
    name: MamografiaPerguntaField.assimetriaDifusaLesaoCancer,
  },
  {
    label: 'Área densa',
    name: MamografiaPerguntaField.areaDensaLesaoCancer,
  },
  {
    label: 'Distorção focal',
    name: MamografiaPerguntaField.distorcaoFocalLesaoCancer,
  },
  {
    label: 'Linfonodo axilar',
    name: MamografiaPerguntaField.linfonodoAxilarLesaoCancer,
  },
]

export const avaliacaoRespostaQuimioterapiaOptions = [
  {
    value: RastreioCancerPerguntaOpcaoEnum.SIM_MAMA_DIREITA,
    label: 'Mama direita',
  },
  {
    value: RastreioCancerPerguntaOpcaoEnum.SIM_MAMA_ESQUERDA,
    label: 'Mama esquerda',
  },
  {
    value: RastreioCancerPerguntaOpcaoEnum.AMBAS,
    label: 'Ambas',
  },
]

export const revisaoMamografiaLesaoAccordionOptions = [
  {
    label: 'Categoria 0',
    name: MamografiaPerguntaField.categoriaZero,
  },
  {
    label: 'Categoria 3',
    name: MamografiaPerguntaField.categoriaTres,
  },
  {
    label: 'Categoria 4',
    name: MamografiaPerguntaField.categoriaQuatro,
  },
  {
    label: 'Categoria 5',
    name: MamografiaPerguntaField.categoriaCinco,
  },
]

export const lesaoBenignaAccordionOptions = [
  {
    label: 'Nódulo',
    name: MamografiaPerguntaField.noduloLesaoBenigna,
  },
  {
    label: 'Microcalcificações',
    name: MamografiaPerguntaField.microcalcificacoesLesaoBenigna,
  },
  {
    label: 'Assimetria focal',
    name: MamografiaPerguntaField.assimetriaFocalLesaoBenigna,
  },
  {
    label: 'Assimetria difusa',
    name: MamografiaPerguntaField.assimetriaDifusaLesaoBenigna,
  },
  {
    label: 'Área densa',
    name: MamografiaPerguntaField.areaDensaLesaoBenigna,
  },
  {
    label: 'Distorção focal',
    name: MamografiaPerguntaField.distorcaoFocalLesaoBenigna,
  },
  {
    label: 'Linfonodo axilar',
    name: MamografiaPerguntaField.linfonodoAxilarLesaoBenigna,
  },
]

export const noduloEspessamentoComboboxItems = [
  RastreioCancerPerguntaOpcaoEnum.QSL,
  RastreioCancerPerguntaOpcaoEnum.QIL,
  RastreioCancerPerguntaOpcaoEnum.QSM,
  RastreioCancerPerguntaOpcaoEnum.QIM,
  RastreioCancerPerguntaOpcaoEnum.UQ_LAT,
  RastreioCancerPerguntaOpcaoEnum.UQ_SUP,
  RastreioCancerPerguntaOpcaoEnum.UQ_MED,
  RastreioCancerPerguntaOpcaoEnum.UQ_INF,
  RastreioCancerPerguntaOpcaoEnum.RRA,
  RastreioCancerPerguntaOpcaoEnum.PA,
]
